import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

interface DownloadButtonProps {
  onClick: () => void;
}

export default function DownloadButton({ onClick }: DownloadButtonProps) {
  return (
    <div className="relative group">
      <button
        type="button"
        className="absolute top-2 right-0 pt-2 rounded-md border border-transparent bg-indigo-600 hover:bg-indigo-700 py-2 px-3 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm z-10"
        onClick={onClick}
      >
        <ArrowDownTrayIcon className="w-5 h-5" />
      </button>
      <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block bg-black text-white text-xs rounded py-1 px-2 whitespace-nowrap z-20">
        Download the last 30 days of device data
      </div>
    </div>
  );
}
